import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Tab, Tabs } from '@mui/material';
import { Palette as PaletteIcon, Straighten as StraightenIcon } from '@mui/icons-material';
import { ColorPropertiesList } from './ColorPropertiesList';
import { SizePropertiesList } from './SizePropertiesList';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`catalog-mappings-tabpanel-${index}`}
      aria-labelledby={`catalog-mappings-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

export const CatalogCodeMappingsPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const initialTab = tabParam === 'sizes' ? 1 : 0;
  const [currentTab, setCurrentTab] = useState(initialTab);

  useEffect(() => {
    // Update tab when URL parameter changes
    const newTab = searchParams.get('tab') === 'sizes' ? 1 : 0;
    setCurrentTab(newTab);
  }, [searchParams]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
    // Update URL to reflect tab change
    const newTab = newValue === 1 ? 'sizes' : 'colors';
    setSearchParams({ tab: newTab });
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          aria-label="catalog code mappings tabs"
        >
          <Tab
            icon={<PaletteIcon />}
            iconPosition="start"
            label="COLORS"
            id="catalog-mappings-tab-0"
            aria-controls="catalog-mappings-tabpanel-0"
            sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          />
          <Tab
            icon={<StraightenIcon />}
            iconPosition="start"
            label="SIZES"
            id="catalog-mappings-tab-1"
            aria-controls="catalog-mappings-tabpanel-1"
            sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          />
        </Tabs>
      </Box>

      <TabPanel value={currentTab} index={0}>
        <ColorPropertiesList />
      </TabPanel>

      <TabPanel value={currentTab} index={1}>
        <SizePropertiesList />
      </TabPanel>
    </Box>
  );
};

export default CatalogCodeMappingsPage;
